export default __webpack_public_path__ + "static/media/explosion.efa35487.webp";